import React from 'react';
import type { FC } from 'react';

import { FAQCategories, FAQCategory } from '../home/faq_categories';

const CATEGORIES: FAQCategory[] = [
  {
    title: undefined,
    questions: [
      {
        question: 'How early should I book an apartment moving service?',
        answer: (
          <>
            We recommend booking your apartment moving service at least 2–4
            weeks in advance, especially during weekends or at the end of the
            month when demand is higher. This helps secure your preferred date
            and ensures our apartment-specialist movers can plan the move
            efficiently.
          </>
        ),
      },
      {
        question: 'What’s the easiest way to move apartments without stress?',
        answer: (
          <>
            Hiring experienced apartment-to-apartment movers is the easiest way
            to take the stress out of moving. Clutter’s full-service apartment
            moving company handles packing, transportation, and unloading — so
            you can settle in without the hassle.
          </>
        ),
      },
      {
        question: 'Do moving companies offer packing for apartment moves?',
        answer: (
          <>
            Yes! Our apartment moving services include professional packing and
            unpacking. Whether you need help with a few items or your entire
            apartment or condo, our apartment movers are trained to handle
            everything with care.
          </>
        ),
      },
      {
        question: 'What apartment building rules should I check before moving?',
        answer: (
          <>
            Before your move, check for elevator reservations, loading dock
            availability, and any specific move-in/move-out time restrictions.
            Our apartment-specialist movers are familiar with apartment building
            protocols and will work with you to meet any requirements.
          </>
        ),
      },
      {
        question: 'What services do you offer?',
        answer: (
          <>
            Clutter offers a range of apartment moving services, including
            packing, loading, transportation, storage, and delivery. Whether you
            need condo movers or apartment-to-apartment movers, we tailor our
            services to meet your needs.
          </>
        ),
      },
      {
        question:
          'What does Clutter do to guarantee the best moving experience?',
        answer: (
          <>
            Clutter is an experienced apartment moving company that prioritizes
            efficiency, safety, and transparency. With real-time tracking,
            secure handling, and no hidden fees, we’re committed to making your
            move smooth from start to finish.
          </>
        ),
      },
      {
        question: 'What are your service areas?',
        answer: (
          <>
            We provide apartment moving services in major cities across the U.S.
            Whether you’re in a high-rise, a walk-up, or a condo, our apartment
            movers are ready to help.
          </>
        ),
      },
      {
        question: 'How many movers and trucks do you send?',
        answer: (
          <>
            The number of movers and trucks depends on the size and complexity
            of your move. For most 1-bedroom apartments, our
            apartment-to-apartment movers typically arrive with 2–3
            professionals and a single moving truck. For larger or condo moves,
            we scale accordingly.
          </>
        ),
      },
    ],
  },
];

export const MovingFAQ: FC = () => (
  <FAQCategories
    headline={<>How early should I book an apartment moving service?</>}
    categories={CATEGORIES}
  />
);
